import "core-js/modules/es.array.push.js";
/* eslint-disable no-undef */
import { useDebounceFn } from "@vueuse/core";
import { useUnsplashServices } from "@/services/unsplash";
const {
  fetchUnsplashPictures,
  fetchUnsplashInfinite
} = useUnsplashServices();

// https://unsplash.com/documentation#rate-limiting

export const useUnsplashStore = defineStore("unsplash", () => {
  const searchUnsplashQuery = ref('');
  const unsplashPictures = ref([]);
  const pageNumber = ref(1);
  const getUnsplashPictures = useDebounceFn(async () => {
    unsplashPictures.value = [];
    try {
      const data = await fetchUnsplashPictures(searchUnsplashQuery.value);
      const parsedData = JSON.parse(data.value || "{}");
      unsplashPictures.value = parsedData.results || [];
    } catch (err) {
      await Promise.reject(err);
    }
  }, 1000);
  async function getUnsplashPicturesInfinite() {
    try {
      const data = await fetchUnsplashInfinite(searchUnsplashQuery.value);
      const parsedData = JSON.parse(data.value);
      if (!parsedData && !parsedData?.results) {
        return;
      }
      unsplashPictures.value.push(...parsedData.results);
    } catch (err) {
      await Promise.reject(err);
    }
  }
  async function changePageNumber(newPageNumber) {
    pageNumber.value = newPageNumber;
    await getUnsplashPictures();
  }
  return {
    searchUnsplashQuery,
    unsplashPictures,
    pageNumber,
    getUnsplashPictures,
    getUnsplashPicturesInfinite,
    changePageNumber
  };
});